import Icons from "@/ui/Icons";
import cn from "@/utils/tailwind/cn";
export const OfficeBannerIcon = ({ className }: { className?: string }) => (
  <Icons.BuildingOffice
    className={cn(
      "inline-block mr-1 relative bottom-0.5 text-[#ffb800]",
      className,
    )}
  />
);
